export const translations = {
  novoCommercialTeam: {
    pt: "Novo time comercial",
    en: "New commercial team",
    de: "Neues Vertriebsteam",
    es: "Nuevo equipo comercial",
  },
  configuracoes: {
    pt: "Configurações",
    en: "Settings",
    de: "Einstellungen",
    es: "Configuración",
  },
  segmentacao: {
    pt: "Customer segmentation",
    en: "Customer segmentation",
    de: "Kundensegmentierung",
    es: "Segmentación de clientes",
  },
}
